
export  function disableScroll() {
    const topFromScrollTop = -1 * document.documentElement.scrollTop + 'px'
    document.body.classList.add('no-scroll')
    document.body.style.top = topFromScrollTop
}

export function enableScroll() {
    const scrollTopFromTop = +document.body.style.top
        .slice(1)
        .substring(0, document.body.style.top.slice(1).length - 2)
    document.body.classList.remove('no-scroll')
    document.documentElement.scrollTop = scrollTopFromTop
}

